var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66732 3.99935C4.66732 2.1584 6.1597 0.666016 8.00065 0.666016C9.8416 0.666016 11.334 2.1584 11.334 3.99935C11.334 5.8403 9.8416 7.33268 8.00065 7.33268C6.1597 7.33268 4.66732 5.8403 4.66732 3.99935ZM8.00065 1.99935C6.89608 1.99935 6.00065 2.89478 6.00065 3.99935C6.00065 5.10392 6.89608 5.99935 8.00065 5.99935C9.10522 5.99935 10.0007 5.10392 10.0007 3.99935C10.0007 2.89478 9.10522 1.99935 8.00065 1.99935Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33398 14.666C1.33398 10.9841 4.31875 8.66602 8.00065 8.66602C11.6826 8.66602 14.6673 10.9841 14.6673 14.666V15.3327H1.33398V14.666ZM2.70858 13.9993H13.2927C12.9647 11.3685 10.7204 9.99935 8.00065 9.99935C5.28091 9.99935 3.03665 11.3685 2.70858 13.9993Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.13eed1dd930ea8dad165fa6dad55b4bb.svg";
export { ForwardRef as ReactComponent };